import { Component, Input } from '@angular/core';

import { environment } from '../../../environments/environment';
import { URL_DOCUWARE } from '../base/util/url-util';


@Component({
	selector: 'app-img-docuware',
	templateUrl: './img-docuware.component.html',
	styleUrls: ['./img-docuware.component.css']
})
export class ImgDocuwareComponent {

	@Input() docuwareID: string;
	@Input() displayMode: boolean = false;

	public loading: boolean = true;

	onLoad() {
		this.loading = false;
	}

	getUrlAnexo(docId: string) {
		const id = docId.split('_')[1];

		return URL_DOCUWARE + id;
	}

	openImgNewWindow(id: string) {
		let urlLocation: string = environment.urlMain + 'get-image/' + id;
		window.open(urlLocation, '', 'width=800,height=600');
	}
}



// WEBPACK FOOTER //
// ./src/app/components/img-docuware/img-docuware.component.ts